<overlay-header [showCloseButton]="true" (closeClick)="closeClick()">Maintain Team</overlay-header>
<div class="flex-header">
  <student-header [disableNavigation]="true">
  </student-header>
  <div>
    <span style="font-weight: bold;">{{collectionName}}</span>
    <span style="padding-left: 20px; padding-right: 5px;">Status</span>
    <span style="font-weight: bold;">{{status}}</span>
  </div>
</div>
<mat-dialog-content>
  <mat-table style="width:100%;" [dataSource]="tylerMatData" multiTemplateDataRows>
    <ng-container matColumnDef="TeamMemberName">
      <mat-header-cell *matHeaderCellDef>
        Name
      </mat-header-cell>
      <mat-cell *matCellDef="let element">
        {{element.TeamMemberName}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="IsCreator">
      <mat-header-cell *matHeaderCellDef style="justify-content: flex-end;">
        Owner
      </mat-header-cell>
      <mat-cell *matCellDef="let element" style="justify-content: flex-end;padding-right: 20px;">
        {{element.IsCreator == true ? 'Y' : ''}} </mat-cell>
    </ng-container>

    <ng-container matColumnDef="Action">
      <mat-header-cell *matHeaderCellDef style="justify-content: flex-end;">
        Actions
      </mat-header-cell>
      <mat-cell *matCellDef="let element let i = index;" style="justify-content: flex-end;" class="print-ignore">
        <a *ngIf="!element.IsCreator" (click)="deleteClick(element)">Delete</a>
      </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="columnToDisplay;" id="Documentheader">
    </mat-header-row>
    <mat-row *matRowDef="let row; columns: columnToDisplay; let i = index;" tabindex="0"
      style="padding:0px;overflow:hidden;border-bottom-width:1px;" matRipple class="element-row">
    </mat-row>
  </mat-table>
  <div id="formAccess" style="margin-top: 20px">
    <b style="font-size: 12pt;">
      <span translate>Form Access</span>
    </b>
    <mat-table #table [dataSource]="studentCollectionTeamMemberPermission" id="tblFormAccess"
      aria-label="Form Access Data Table" tabindex="0">
      <ng-container *ngFor="let column of columnToDisplayForm; ; let i = index" matColumnDef="{{column}}">
        <mat-header-cell
          [ngStyle]="{'min-width': column == 'FormName' ? '350px' : '200px', 'max-width': column == 'FormName' ? '350px' : '200px', 'display':'flex', 'flex-direction': column != 'FormName' ? 'column' : 'unset', 'align-items': 'stretch', 'border-left': column != 'FormName' ? 'thin solid lightgray' : 'none' }"
          *matHeaderCellDef>
          <div translate style="padding-left: 5px;">{{column | maintainTeamMemberHeaderName : teamMembers}}
            <!-- {{getColumnHeaderName(column)}} -->
          </div>
          <div *ngIf="column != 'FormName' && (column | isFormCreator : teamMembers) == false">
            <mat-radio-group id="{{column}}" name="radio_{{column}}"
              (ngModelChange)="typeSelected = $event; selectedTypeChange(column, $event)"
              [ngModel]="typeSelected | headerModelValue : column : studentCollectionTeamMemberPermission"
              style="display: flex; flex-direction: column; padding-left: 5px;">
              <mat-radio-button [value]="'False'">View</mat-radio-button>
              <mat-radio-button [value]="'True'">Edit</mat-radio-button>
              <mat-radio-button [value]="'viewEdit'">Select</mat-radio-button>
            </mat-radio-group>
          </div>
        </mat-header-cell>
        <mat-cell *matCellDef="let teamMemberData; let j = index"
          [ngStyle]="{'min-width': column == 'FormName' ? '350px' : '200px', 'max-width': column == 'FormName' ? '350px' : '200px'}"
          style="border-left: thin solid lightgray;">
          <div *ngIf="column == 'FormName'">
            {{column | maintainTeamMemberCellValue : j : studentCollectionTeamMemberPermission}}
            <!-- {{getCellValue(column, j)}} -->
          </div>
          <div *ngIf="column != 'FormName'" style="padding-left: 5px;">
            <mat-radio-group [(ngModel)]="teamMemberData[column]" (change)="selectMode(column)"
              (ngModelChange)="typeSelected = $event;">
              <mat-radio-button [disabled]="(column | isFormCreator : teamMembers) == true" [value]="'False'">View
              </mat-radio-button>
              <mat-radio-button [disabled]="(column | isFormCreator : teamMembers) == true" [value]="'True'">Edit
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="columnToDisplayForm">
      </mat-header-row>
      <mat-row *matRowDef="let row; columns:  columnToDisplayForm; let j = index;" id="formAccessDataRow{{j}}"
        tabindex="0" style="padding:0px;overflow: hidden;"></mat-row>
    </mat-table>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="flex-footer">
    <div class="flex-footer-left">
      <tyl-button id="addTeamMember" (clickEvent)="addStaffClick()" image="add.png" label="Add Team Member">
      </tyl-button>
    </div>
    <div class="flex-footer-right">
      <tyl-button id="saveButton" (clickEvent)="saveClick()" image="save.png" label="Save and Close">
      </tyl-button>
      <tyl-button id="cancelButton" image="cancel.png" label="Cancel" (clickEvent)="CancelClick()"></tyl-button>
    </div>
  </div>
</mat-dialog-actions>